import { useEffect, useState } from "react";
import api from "@/lib/api";

let cache = null;
const listeners = new Set();

export function invalidateVisibility() {
  cache = null;
  listeners.forEach((fn) => fn(null));
}

export function refreshVisibility() {
  return api.get("/feature_visibility").then(({ data }) => {
    cache = data;
    listeners.forEach((fn) => fn(data));
    return data;
  }).catch(() => {
    cache = { my_access: { schedule: true, template: true, weekly: true } };
    listeners.forEach((fn) => fn(cache));
    return cache;
  });
}

export function useVisibility(userId) {
  const [data, setData] = useState(cache);
  useEffect(() => {
    listeners.add(setData);
    // Always re-fetch when the user identity changes (login / logout / user switch)
    refreshVisibility();
    return () => { listeners.delete(setData); };
  }, [userId]);
  return data;
}

export function canSee(access, featureKey) {
  if (!access) return true;
  return access[featureKey] !== false;
}
